import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-barcode',
  templateUrl: './barcode.component.html',
  styleUrls: ['./barcode.component.css']
})
export class BarcodeComponent implements OnInit {
  innerHeight: number = window.innerHeight;
  bookingRef:any;
  
  constructor(
    @Inject(MAT_DIALOG_DATA) data:any,
    public dialogRef: MatDialogRef<BarcodeComponent>,
     
  ) { 
   
    this.bookingRef=data;
    
  }

  ngOnInit() {
  }
  closeDial() {
    this.dialogRef.close();
  }
}
